<template>
    <div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="msuList" :data="msuList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" width="55"></el-table-column>
                    <el-table-column prop="title" label="显示名称" align="center"></el-table-column>
                    <el-table-column prop="generallFee" label="服务费" align="center"></el-table-column>
                    <el-table-column prop="shelfState" label="上架状态" align="center">
                        <template slot-scope="rows">
                            <el-tag type="danger" v-if="rows.row.shelfState === 0" close-transition>未上架</el-tag>
                            <el-tag type="success" v-if="rows.row.shelfState === 1" close-transition>已上架</el-tag>
                            <el-tag type="danger" v-if="rows.row.shelfState === 2" close-transition>已下架</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="msuList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checlMsuInfo!= null && checlMsuInfo.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="显示名称" align="center"></el-table-column>
                    <el-table-column prop="generallFee" label="服务费" align="center"></el-table-column>
                    <el-table-column prop="shelfState" label="上架状态" align="center">
                        <template slot-scope="rows">
                            <el-tag type="danger" v-if="rows.row.shelfState === 0" close-transition>未上架</el-tag>
                            <el-tag type="success" v-if="rows.row.shelfState === 1" close-transition>已上架</el-tag>
                            <el-tag type="danger" v-if="rows.row.shelfState === 2" close-transition>已下架</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servcApi from '../../api/servc'

    export default {
        name: 'swb-msu-list-select',
        desc: '服务单选/多选',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            ssuIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                msuList: [],
                selectMsuList: [],
                checlMsuInfo: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getMsuPageList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getMsuPageList();
            },
            getMsuPageList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = self.filter;
                let theLoad = MsgBox.loading();
                servcApi.getMsuPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let data = result.data;
                        let msuList = data.rows;
                        //
                        self.msuList = msuList;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let ssuIds = this.ssuIds;
                if(ssuIds.indexOf(row.ssuId) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectMsuList = val;
            },
            handleCurrentChange: function (val) {
                this.checlMsuInfo = Utils.merge({}, val);
            },
            getSsuInfo: function (msuInfo) {
                let ssuInfo = {};
                if(msuInfo != null) {
                    ssuInfo.id = msuInfo.ssuId;
                    ssuInfo.servcId = msuInfo.servcId;
                    ssuInfo.mkuId = msuInfo.id;
                    ssuInfo.title = msuInfo.title;
                    ssuInfo.toDoorFee = msuInfo.toDoorFee;
                    ssuInfo.generallFee = msuInfo.generallFee;
                    ssuInfo.shelfState = msuInfo.shelfState;
                }
                return ssuInfo;
            },
            getSkuList: function () {
                let ssuList = [];
                let msuList = this.selectMsuList;
                if(msuList != null && msuList.length > 0) {
                    for(var i = 0; i < msuList.length; i++) {
                        let msuInfo = msuList[i];
                        let ssuInfo = this.getSsuInfo(msuInfo);
                        ssuList.push(ssuInfo);
                    }
                }
                return ssuList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let msuList = self.selectMsuList;
                    if(msuList != null && msuList.length > 0) {
                        result.type = "info";
                        result.data = self.getSkuList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个服务！';
                    }
                } else {
                    let msuInfo = self.checlMsuInfo;
                    if(msuInfo != null) {
                        result.type = "info";
                        result.data = self.getSsuInfo(msuInfo);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个服务！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servc/MsuListSelect.vue